<template>
  <div class="registrationInfoBox">
    <div class="mainContentBox">
      <div class="registrationInfoList">
        <div class="registrationInfoListItem">
          <div class="registrationInfoTitle">企业性质</div>
          <div
            class="registrationInfoData"
          >{{format.enterpriseNature ? format.enterpriseNature : '暂无'}}</div>
        </div>
        <div class="registrationInfoListItem">
          <div class="registrationInfoTitle">注册资本</div>
          <div
            class="registrationInfoData"
          >{{format.registerCapital ? format.registerCapital : '暂无'}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      format: {}
    };
  },
  created() {
    this.format = this.$route.query;
  }
};
</script>

<style lang="less" scoped>
.registrationInfoBox {
  width: 100%;
  height: 100%;
  color: #333;
  padding: 16px 12px 0 12px;
  background-color: #fbfbfb;
  .mainContentBox {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    .registrationInfoList {
      .registrationInfoListItem::after {
        content: "";
        display: block;
        clear: both;
      }
      .registrationInfoListItem {
        font-size: 16px;
        line-height: 48px;
        height: 48px;
        padding: 0 12px;

        border-bottom: 1px solid #eeeeee;
        .registrationInfoTitle {
          color: #999;
          float: left;
        }

        .registrationInfoData {
          margin-left: 88px;
        }
      }
    }
  }
}
</style>
